// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material/styles";
import useTranslation from "next-translate/useTranslation";

import { Grid, Button, Typography } from "@/components/core";

export function AccountCardNot({ account }: any) {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const ACCOUNT_COLOR = {
    TRY: theme.modules.account.try.main,
    EUR: theme.modules.account.eur.main,
    USD: theme.modules.account.usd.main,
    GBP: theme.modules.account.gbp.main,
  };

  return (
    <Grid>
      {account.iban != null ? (
        <Button
          startIcon={<AddIcon />}
          sx={{
            p: 3,
            width: "100%",
            backgroundColor: ACCOUNT_COLOR[account.currency],
            "&:hover": {
              backgroundColor: ACCOUNT_COLOR[account.currency],
            },
            color: theme.palette.text.contrast,
            borderRadius: 3,
          }}
        >
          <Grid spacing={5} alignItems="flex-start">
            <Grid.Item>
              <Grid.Item>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {account.currencyLabel} {t("openAccount")}
                </Typography>
              </Grid.Item>
            </Grid.Item>
          </Grid>
        </Button>
      ) : null}
    </Grid>
  );
}

AccountCardNot.propTypes = {
  account: PropTypes.shape({
    currency: PropTypes.string,
    currencyLabel: PropTypes.string,
    balance: PropTypes.number,
    iban: PropTypes.string,
    orderNumber: PropTypes.number,
    SepaIban: PropTypes.string,
  }),
};
